import React from 'react';
import EasterSvg from '@assets/decorations/easter/easter.svg?url';
import * as S from './Styles';

export const Easter = () => (
  <S.EasterWrapper>
    <img src={EasterSvg} alt="Dekorasjon av navigasjon" />
  </S.EasterWrapper>
);
